const log = (...args: unknown[]) => {
  let debug
  try {
    debug = localStorage.getItem('webby-debug')
  } catch {
    /* continue regardless of error */
  }
  if (debug) {
    console.log('[Webby] ', ...args) // oxlint-disable-line no-console
  }
}

const serialize = (obj: Record<string, any>, prefix: string | null = null): string => {
  const str: string[] = []

  Object.keys(obj).forEach(k => {
    const key = prefix ? `${prefix}[${k}]` : k
    const value = obj[k]
    str.push(
      value !== null && typeof value === 'object'
        ? serialize(value, key)
        : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
  })

  return str.join('&')
}

const stopPropagation = <T extends Element>(e: Event | React.SyntheticEvent<T>) => {
  e.stopPropagation()
  e.preventDefault()
}

const digestMessage = async (string: string, algorithm = 'SHA-256') => {
  const utf8 = new TextEncoder().encode(string)
  const hashBuffer = await crypto.subtle.digest(algorithm, utf8)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map(bytes => bytes.toString(16).padStart(2, '0')).join('')
  return hashHex
}

const pluralize = (count: number, noun: string, suffix = 's') => `${count} ${noun}${count !== 1 ? suffix : ''}`

export { log, serialize, stopPropagation, digestMessage, pluralize }
